import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class UserLogout extends Event {
    eventName = 'oms_userLogout';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for User logout
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;

        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let locationId = new LocalStorage.CurrentLocation(clientId).getData();

        if (clientId) {

            let userDetails = new LocalStorage.UserDetails(clientId);
            userDetails.removeData();

            let userData = new LocalStorage.UserData(clientId);
            userData.removeData();
            
            let cartLocation = new LocalStorage.CartLocation(locationId);
            cartLocation.removeData();

            let cartId = new LocalStorage.CartId(locationId);
            cartId.removeData();

            //format response data
            let data = [];//thisObj.formatResponseData([]);
            
            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default UserLogout;